import generateIcon from 'components/_particles/icon/icon';
import { t } from './withTranslation';

export function toggleCollapse(
  $toggle,
  config = {
    closedButtonText: undefined,
    openButtonText: undefined,
    toggleTextClass: undefined,
    // Class of Element to scroll to (toggleButton needs to be a child of this Element!), when closing the collapse, default is the toggle button
    scrollTargetClass: undefined,
    addCloseButton: false,
    closeIcon: undefined,
    openIcon: undefined, // if defining one icon you also need to define the other
  }
) {
  if (!$toggle) {
    console.error('toggleCollapse: missing $toggle');
    return;
  }

  const $toggleButton = $toggle;
  const $target = document.querySelector(
    `#${$toggleButton.getAttribute('aria-controls')}`
  );

  if (!$target) {
    console.error('toggleCollapse: missing target', $toggleButton);
    return;
  }

  const isCurrentlyExpanded = $target.getAttribute('aria-hidden') === 'false';
  const isExpanded = !isCurrentlyExpanded;
  const targetHeight = $target.clientHeight;
  $target.setAttribute('aria-hidden', isCurrentlyExpanded ? 'true' : 'false');
  // if there is also a close button triggering the collapse, the other toggle button needs to be updated as well
  document
    .querySelectorAll(
      `[aria-controls=${$toggleButton.getAttribute('aria-controls')}]`
    )
    .forEach(($el) => {
      $el.setAttribute('aria-expanded', isCurrentlyExpanded ? 'false' : 'true');
    });
  if (
    config.closedButtonText ||
    config.openButtonText ||
    config.openIcon ||
    config.closeIcon
  ) {
    const $textWrap = config.toggleTextClass
      ? $toggleButton.querySelector(`.${config.toggleTextClass}`)
      : $toggleButton;
    $textWrap.textContent = isExpanded
      ? config.openButtonText || $textWrap.textContent
      : config.closedButtonText || $textWrap.textContent;

    if (config.openIcon && config.closeIcon) {
      const $svgUse = $toggleButton.querySelector('svg use');
      const iconHref = isExpanded ? config.closeIcon : config.openIcon;
      if (iconHref) {
        // xlink:href requires namespace for older browsers
        $svgUse.setAttributeNS(
          'http://www.w3.org/1999/xlink',
          'xlink:href',
          iconHref
        );
        // href for modern browsers
        $svgUse.setAttribute('href', iconHref);
      }
    }
  }

  if (isExpanded) {
    if (config?.addCloseButton) {
      $target
        .querySelectorAll('.collapse__close')
        .forEach((btn) => btn.remove());
      const $closeButton = document.createElement('button');
      $closeButton.setAttribute('type', 'button');
      $closeButton.setAttribute(
        'class',
        'button button--small button--chromeless button--icon collapse__close'
      );
      $closeButton.setAttribute('aria-expanded', 'true');
      const $icon = generateIcon({ icon: 'close' });
      $closeButton.appendChild($icon);
      $closeButton.setAttribute('aria-label', t('Schließen'));
      $closeButton.setAttribute('aria-controls', $target.getAttribute('id'));
      $closeButton.addEventListener('click', () => {
        toggleCollapse($closeButton);
      });
      $target.appendChild($closeButton);
    }
    const focusable = $target.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    const firstFocusable = focusable?.[0];
    firstFocusable?.focus();
  } else {
    $toggleButton.focus();
    if (targetHeight > 300) {
      const $scrollTarget =
        $toggleButton.closest(`.${config.scrollTargetClass}`) || $toggleButton;
      $scrollTarget?.scrollIntoView({
        behavior: 'smooth',
      });
    }
  }
}

export default toggleCollapse;
